export default __webpack_public_path__ + "static/media/Initiate's Leggings of the Heavens.b5ad7009.jpg";